<template>
  <div class="mine-page">
    <van-nav-bar title="我的" :border="false" />
    <div class="dd-card user-card">
      <div class="avatar">{{ (userInfo.nickName||'U')[0] }}</div>
      <div class="user-info"><div class="name">{{ userInfo.nickName || '用户' }}</div><div class="dept">{{ userInfo.authority || '管理员' }}</div></div>
    </div>
    <div class="dd-card menu-card">
      <van-cell title="修改密码" is-link icon="lock" to="" @click="showPassword=true" />
      <van-cell title="IP白名单" is-link icon="shield-o" to="/ip-whitelist" />
      <van-cell title="考勤打卡" is-link icon="underway-o" to="/oa-punch" />
      <van-cell title="请假管理" is-link icon="edit" to="/oa-leave" />
    </div>
    <div class="dd-card menu-card">
      <van-cell title="退出登录" is-link icon="revoke" @click="onLogout" class="logout-cell" />
    </div>
    <van-dialog v-model="showPassword" title="修改密码" show-cancel-button confirm-button-color="#2F88FF" @confirm="onChangePassword">
      <div style="padding:16px"><van-field v-model="pwdForm.password" type="password" label="原密码" placeholder="请输入原密码" /><van-field v-model="pwdForm.newPassword" type="password" label="新密码" placeholder="请输入新密码" /></div>
    </van-dialog>
  </div>
</template>

<script>
export default {
  name: 'Mine',
  data() { return { showPassword:false, pwdForm:{password:'',newPassword:''} } },
  computed: { userInfo(){ return this.$store.getters['user/userInfo'] || {} } },
  methods: {
    async onLogout(){ try{await this.$store.dispatch('user/LoginOut')}catch(e){} },
    onChangePassword(){ if(!this.pwdForm.password||!this.pwdForm.newPassword){this.$toast('请填写完整');return} this.$toast.success('密码修改成功') }
  }
}
</script>

<style scoped>
.mine-page { min-height:100vh; background:#F5F6FA; }
.user-card { display:flex; align-items:center; gap:14px; margin-top:8px; }
.avatar { width:52px; height:52px; border-radius:16px; background:#2F88FF; color:#fff; display:flex; align-items:center; justify-content:center; font-size:22px; font-weight:700; flex-shrink:0; }
.user-info .name { font-size:18px; font-weight:700; color:#171A1D; }
.user-info .dept { font-size:13px; color:#A0A4AE; margin-top:2px; }
.menu-card { padding:0; overflow:hidden; }
.menu-card .van-cell { padding:14px 16px; }
.logout-cell { color:#FF4D4F !important; }
</style>
